import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag } from '@fortawesome/free-solid-svg-icons';
import '../styles/TagDisplay.css';

function TagDisplay({ tags, onTagClick, maxDisplay = 5, className = '' }) {
  if (!tags) return null;
  
  // Parse tags from string
  const tagList = tags.split(',').map(tag => tag.trim()).filter(tag => tag.length > 0);
  
  if (tagList.length === 0) return null;
  
  const displayTags = tagList.slice(0, maxDisplay);
  const remainingCount = tagList.length - maxDisplay;
  
  return (
    <div className={`tag-display ${className}`}>
      {displayTags.map((tag, index) => (
        <span 
          key={index} 
          className={`tag-pill ${onTagClick ? 'clickable' : ''}`}
          onClick={() => onTagClick && onTagClick(tag)}
          title={onTagClick ? `Click to filter by "${tag}"` : tag}
        >
          <FontAwesomeIcon icon={faTag} className="tag-pill-icon" />
          {tag}
        </span>
      ))}
      {remainingCount > 0 && (
        <span className="tag-pill tag-more" title={tagList.slice(maxDisplay).join(', ')}>
          +{remainingCount} more
        </span>
      )}
    </div>
  );
}

export default TagDisplay;